import React from 'react';
import IndustryTemplate, { IndustryConfig } from './IndustryTemplate';

const config: IndustryConfig = {
  slug: 'services',
  label: 'Service',
  heroTitle: 'Monetize Your',
  heroDim: 'Service Data',
  heroSubtitle:
    'Everything from spas to fitness studios generate rich, undervalued data every day. Efficient helps you turn it into revenue you can put back into your business.',
  heroImage: '/hair-salon-hero.webp',
  heroImageAlt: 'Personal services professional at work',
  processSteps: [
    {
      num: '01',
      icon: '/step_door.svg',
      title: 'Data Assessment',
      desc: 'We review your booking records, service history, and client data to identify what\'s valuable and market-ready.',
    },
    {
      num: '02',
      icon: '/step_onboard.svg',
      title: 'Qualification',
      desc: 'We match your data to AI buyers in the wellness, beauty, retail, and consumer behavior spaces and provide a clear quote.',
    },
    {
      num: '03',
      icon: '/step_extract.svg',
      title: 'Preparation',
      desc: 'We anonymize client data, structure service records, and prepare your dataset for compliant delivery.',
    },
    {
      num: '04',
      icon: '/step_paid.svg',
      title: 'Revenue Recognition',
      desc: 'You earn a revenue share on every transaction — turning your daily operations into a new income stream.',
    },
  ],
  valueHeading: 'What personal services data can be monetized',
  valueProps: [
    {
      title: 'Appointment & Booking Patterns',
      desc: 'How clients book, cancel, and return captures the real cadence of your business — patterns of loyalty and demand that take years of operation to accumulate.',
    },
    {
      title: 'Service & Treatment Preferences',
      desc: 'Records of services performed and products used reflect the genuine preferences and needs of your clientele, built up through thousands of individual appointments.',
    },
    {
      title: 'Pricing & Menu Structures',
      desc: 'Your service pricing and menu reflect hard-earned knowledge of what clients value — the expertise of knowing what to offer, at what price, for great service.',
    },
  ],
  aiAccelHeading: 'Keep your clients. Fill your calendar. Grow your revenue.',
  aiAccelPoints: [
    {
      title: 'Smart Scheduling & No-Show Reduction',
      desc: 'AI-powered booking tools predict no-shows, optimize your schedule, and send personalized reminders that keep your calendar full.',
    },
    {
      title: 'Client Retention & Rebooking',
      desc: 'Automatically identify clients who are overdue for a visit and trigger personalized outreach before they book elsewhere.',
    },
    {
      title: 'Product & Service Recommendations',
      desc: 'AI models trained on your service history can suggest add-ons and retail products at checkout — increasing average ticket without extra effort.',
    },
  ],
  ctaHeading: 'Your business data is worth more than you think',
  ctaBody:
    'Join our network of personal services partners and start generating revenue from data your business already produces every day.',
};

export default function HairSalons() {
  return <IndustryTemplate config={config} />;
}
